// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm } from 'rc-form';
import { connect } from 'react-redux';
import { getNearestHalfHour } from '../../core/util/date';
import { symptomsSubmit } from '../../actions/symptoms';
import {
  bookingTimeSelected,
  receiveUserProfileForNewBooking,
  setLocationId,
} from '../../actions/newBooking';
import { setCurrentlySelectedLocation } from '~/ducks/currentlySelectedLocation';
import { convertSnakeToCamelCase, isEmptyObject } from '../../core/util/object';
import { getReasonForVisit } from '../../core/util/form';
import CDPBookingForm from './CDPBookingForm';
import history from '../../core/history';
import { getActiveProfileFromState, getProfileFromAccountSummary } from '../../core/util/account';
import { getSelectorOption } from '../Form/UserProfileSelector';
import { profileFormSubmission } from '../../actions/profile';
import withAuthentication from '../../core/login/withAuthentication';
import { apiGetDispatchable } from '../../core/dapi';
import { getLocationSlotsUrl } from '../../core/dapi/location';
import { locationSlotsError, receiveLocationSlots } from '../../actions/location';
import { BOOKING_FORM_PROFILE_ORIGIN_CDP } from '../../core/util/bookingFlowRouting';
import { transitionToPaymentStep } from '../BookingFlow/util';
import { AccountSummary } from '~/reducers/account';
import { getBookingFlowEntryRoute } from '~/routes/book/components/BookingFlow/util';
import { isPaymentCollectionDuringBookingEnabled } from '~/core/util/location';
import withCustomLDConsumer from '~/core/launch-darkly/hoc/withCustomLDConsumer';

const mapStateToProps = (state: any, ownProps: any) => {
  const getAppointmentTime = () => {
    if (state.newBooking.booking.appointmentTime) {
      return state.newBooking.booking.appointmentTime;
    }

    if (state.newBooking.booking.requestedAppointmentTime) {
      return state.newBooking.booking.requestedAppointmentTime;
    }

    return getNearestHalfHour();
  };

  return {
    account:
      !isEmptyObject(state.login) && !isEmptyObject(state.login.account) ? state.login.account : {},
    accountSummary: state.account.summary,
    userProfile: getActiveProfileFromState(state),
    initialValues: {
      symptoms: getReasonForVisit(
        state.newBooking.booking.reasonForVisit || ownProps.previousBooking.reason
      ),
      appointmentTime: getAppointmentTime(),
      userProfile: getSelectorOption(getActiveProfileFromState(state)),
    },
    isSlotFetching: !(state.location.locationSlotsReceived || state.location.slotsFetchError),
    theme: state.theme,
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  fetchLocationSlotsData: (locationId: string) => {
    dispatch(
      apiGetDispatchable(
        getLocationSlotsUrl(locationId),
        receiveLocationSlots,
        locationSlotsError(locationId)
      )
    );
  },
  handleFormSubmit: (form: any) => {
    dispatch(symptomsSubmit(form));
    if (ownProps?.location?.id) dispatch(setLocationId(ownProps.location.id));
    if (ownProps?.location) dispatch(setCurrentlySelectedLocation(ownProps.location));
    if (ownProps.onPostSubmit) {
      ownProps.onPostSubmit();
    }

    const useNewBookingFlow = ownProps.flags.kis511H22022BookingFlow;

    if (!useNewBookingFlow && ownProps.isLoggedIn && ownProps?.location) {
      transitionToPaymentStep(dispatch, ownProps.location);
    } else {
      history.push(
        getBookingFlowEntryRoute(
          useNewBookingFlow,
          BOOKING_FORM_PROFILE_ORIGIN_CDP,
          isPaymentCollectionDuringBookingEnabled(ownProps.location)
        )
      );
    }
  },

  handleDispatchTimeChange: (value: any) => {
    if (value) dispatch(bookingTimeSelected(value.value));
  },

  setBookingProfile: (accountSummary: AccountSummary, userProfileId: string) => {
    const userProfile = getProfileFromAccountSummary(accountSummary, userProfileId);
    if (userProfile) {
      dispatch(receiveUserProfileForNewBooking(userProfile));
    }

    dispatch(
      profileFormSubmission({
        ...convertSnakeToCamelCase(userProfile),
        phone: accountSummary.phone,
        email: accountSummary.email,
      })
    );
  },
});

const ConnectedCDPBookingForm = withAuthentication(
  withCustomLDConsumer()(connect(mapStateToProps, mapDispatchToProps)(CDPBookingForm))
);

export default createForm()(ConnectedCDPBookingForm);
